<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP

========================================================================================== -->

<template>
	<div id="app">
		<router-view></router-view>
		<vs-popup class="holamundo" :title="$t('Notify.Notification')" :active.sync="isPopupActive">
			<p>{{ $t("Notify.DownloadAppWarning") }}</p>
			<div class="flex justify-around my-4">
				<a class="w-5/12" href="https://play.google.com/store/apps/details?id=com.comay.beontime">
					<img class="w-full" src="@/assets/images/appstore/google.svg" alt="" />
				</a>
				<a class="w-5/12" href="https://apps.apple.com/us/app/be-on-time/id1487048201">
					<img class="w-full" src="@/assets/images/appstore/apple.svg" alt="" />
				</a>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import { isMobile } from "@/mixins/mixins";
import themeConfig from "@/../themeConfig";
import jwt from "@/http/requests/auth/jwt/graphql";

export default {
	mixins: [isMobile],
	watch: {
		"$store.state.theme"(val) {
			this.toggleClassInBody(val);
		}
	},
	data() {
		return {
			isPopupActive: false
		};
	},
	methods: {
		toggleClassInBody(className) {
			if (className === "dark") {
				if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
				document.body.classList.add("theme-dark");
			} else if (className === "semi-dark") {
				if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
				document.body.classList.add("theme-semi-dark");
			} else {
				if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
				if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
			}
		},
		handleWindowResize() {
			this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
		},
		handleScroll() {
			this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
		},
		handleShowMobileWarning() {
			if (this.mixinIsMobile()) {
				const oneDay = 60 * 60 * 24 * 1000; // 24 hours
				const latestShowWarningTime = localStorage.getItem("latestWarningTime");
				if (!latestShowWarningTime || latestShowWarningTime && new Date() - new Date(latestShowWarningTime) > oneDay) {
					this.isPopupActive = true;
					localStorage.setItem("latestWarningTime", new Date());
				}
			}
		}
	},
	async created() {
		// jwt
		jwt.init();

		window.addEventListener("resize", this.handleWindowResize);
		window.addEventListener("scroll", this.handleScroll);
		this.handleShowMobileWarning();
	},
	mounted() {
		this.toggleClassInBody(themeConfig.theme);
		this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
	},
	destroyed() {
		window.removeEventListener("resize", this.handleWindowResize);
		window.removeEventListener("scroll", this.handleScroll);
	}
};
</script>
